import { ReactElement } from 'react';

import {
  DashboardLoadingWrapper,
  DashboardCompleteInitialConfigWrapper,
  DashboardWidgetsWrapper,
} from '../../../../Wrappers';

const DashboardVariantV2Giver = (): ReactElement => {
  return (
    <DashboardLoadingWrapper loading={false}>
      <DashboardCompleteInitialConfigWrapper
        vehiclesCount={1}
        warehousesCount={1}
        onComplete={() => {}}
      >
        <DashboardWidgetsWrapper>
          <div>DashboardVariantV2Giver</div>
        </DashboardWidgetsWrapper>
      </DashboardCompleteInitialConfigWrapper>
    </DashboardLoadingWrapper>
  );
};

export default DashboardVariantV2Giver;
